export default __webpack_public_path__ + "a3df9c30e860b447123064269b3587fe.png";